/* @flow */
import * as React from "react";
import MuiLinearProgress from "@material-ui/core/LinearProgress";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";

const style = {
  borderRadius: 0,
};

type Props = {
  indeterminate: ?boolean,
  min: number,
  max: number,
  value: number,
  colors: ColorSet,
};

class LinearProgress extends React.Component<Props> {
  static defaultProps = {
    indeterminate: false,
    min: 0,
    max: 100,
    value: 0,
  };

  render() {
    const { indeterminate, min, max, value, colors } = this.props;

    return (
      <div data-component-name="LinearProgress">
        {/* MuiLinearProgress doesn't respect the muiTheme (even though it needs a ThemeProvider). So we pass a color prop */}
        {indeterminate ? (
          <MuiLinearProgress
            primary={colors.SECONDARY}
            mode="indeterminate"
            style={style}
          />
        ) : (
          <MuiLinearProgress
            primary={colors.SECONDARY}
            min={min}
            max={max}
            value={value}
            mode="determinate"
            style={style}
          />
        )}
      </div>
    );
  }
}

export default withColorsProvider(LinearProgress);



// WEBPACK FOOTER //
// ../nx-components/src/LinearProgress.jsx